import { AmrDataRequestTabsComponent } from './amr-data-request-tabs.component';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { useDataRequestAdminPath } from '@vivli/features/data-requests/infrastructure/hook';
import { DataRequestStatusEnum } from '@vivli/features/data-requests/infrastructure/enum';
import { useActiveUserContext, useDataRequestPermissionsContext } from '@vivli/core/infrastructure/context';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

export const AmrDataRequestDcTabsComponent = () => {
    const { dataRequest, organizations } = useDataRequestContext();
    const { shouldHideReviewers } = useDataRequestPermissionsContext();
    const isDataRequestsView = useDataRequestAdminPath();
    const { hasPermission, hasAnyPermission } = useActiveUserContext();
    //TODO PERMFE - redo with permissions+
    const isOrgAdmin = !hasPermission(PermissionsEnum.DrActAdv) && hasAnyPermission(PermissionsEnum.ProviderActAdv);
    const isDraft = dataRequest.status === DataRequestStatusEnum.Draft;
    const hideReviewers = shouldHideReviewers(dataRequest, organizations);
    const showRequestTab = isDraft && !isDataRequestsView;
    const showPrintTab = !hideReviewers && (isDataRequestsView || (!isDraft && !isDataRequestsView));

    return (
        <AmrDataRequestTabsComponent
            showRequestTab={showRequestTab}
            showPrintTab={showPrintTab}
            showRequestPrintTab={false} //admin only
            showStatusUpdateTab={isOrgAdmin}
        />
    );
};
